import React from 'react'
import { useTranslation } from 'react-i18next'

import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox'
import { MultiSelect, MultiSelectProps } from 'primereact/multiselect'
import { TooltipOptions } from 'primereact/tooltip/tooltipoptions'
import { classNames } from 'primereact/utils'

export interface MultiSelectToggleableProps extends MultiSelectProps {
  checked: boolean
  onCheckedChange: (event: CheckboxChangeEvent) => void
  checkboxTooltip?: string
  checkboxTooltipOptions?: TooltipOptions
}

export const MultiSelectToggleable: React.FC<MultiSelectToggleableProps> = ({
  checked = false,
  onCheckedChange,
  checkboxTooltip,
  checkboxTooltipOptions,
  disabled,
  ...props
}) => {
  const { t } = useTranslation()

  if (disabled) return <MultiSelect disabled={disabled} {...props} />

  return (
    <div className="p-inputgroup">
      <span
        className={classNames('p-inputgroup-addon', { 'p-disabled': !checked })}
      >
        <Checkbox
          checked={checked}
          onChange={onCheckedChange}
          tooltip={
            checkboxTooltip ||
            t('components.inputs.inputTextToggleable.checkBoxTooltip')
          }
          tooltipOptions={{
            ...checkboxTooltipOptions,
            position: checkboxTooltipOptions?.position || 'left',
          }}
        />
      </span>
      <MultiSelect disabled={disabled || !checked} {...props} />
    </div>
  )
}
